import React, { useEffect, useState } from 'react';
import { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { useApi } from '../../contexts/ApiContext';
import { Lease } from '../../models/Lease';

interface LeaseSummaryProps {
  assetId: number;
}

const LeaseSummary: React.FC<LeaseSummaryProps> = ({ assetId }) => {
  const api = useApi();
  const [leases, setLeases] = useState<Lease[]>([]);

  useEffect(() => {
    api.get<Lease[]>(`/api/Lease/List?assetId=${assetId}`).then(({ data }) => {
      setLeases(data);
    });
  }, [assetId]);

  return (
    <div className="mt-8 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                    Lease
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <Link to={`/leases/0/edit/${assetId}`} className="btn btn-link">
                      Create Lease
                    </Link>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {leases.map((lease) => (
                  <tr key={lease.id}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                      <Link to={`/leases/${lease.id}`} className="btn-link">
                        {lease.name}
                      </Link>
                    </td>
                    <tr className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaseSummary;
